import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Image from '@base/Image';
import PropTypes from 'prop-types';
import { commas } from '@utils/textHelper';
import P1 from '@base/P1/P1';
import H5 from '@base/H5/H5';
import useWindowSize from '@hooks/useWindowSize';
import { REWARD_TYPES } from './constants';

const StatsWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
`;

const StatsTabs = styled.div`
  display: flex;
  width: 100%;
  gap: ${Spacings.SPACING_4B};
  align-items: center;
  padding: ${Spacings.SPACING_4B};
  border: 1px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
`;

const StatsTabsInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_0B};
  }
`;

const StatsTabsValue = styled(H5)``;

const StatsTabsLabel = styled(P1)`
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    font-weight: ${Fonts.LIGHT};
    font-size: ${Fonts.H7};
    line-height: ${Fonts.LARGE};
  }
`;

const RewardIcon = {
  VOUCHER: 'settings/referral/amazon-voucher.svg',
  EXTENSION: 'settings/referral/bonus-reward.svg'
};

const ReferralStatsInfo = ({ rewards, isImgReq = true }) => {
  const getStatsValue = (reward, reverseUnit) => {
    return reverseUnit ? (
      <StatsTabsValue>{`${reward.unit}${commas(reward.value)}`}</StatsTabsValue>
    ) : (
      <StatsTabsValue>{`${commas(reward.value)} ${
        reward.unit
      }`}</StatsTabsValue>
    );
  };
  const { isMobile } = useWindowSize();

  return (
    <StatsWrapper className="stats-wrapper">
      {rewards?.map((reward, index) => (
        <StatsTabs key={String(index)}>
          {isImgReq === false && isMobile ? (
            ''
          ) : (
            <Image
              src={RewardIcon[reward.type]}
              width={40}
              height={40}
              alt={reward.type}
            />
          )}
          <StatsTabsInfo>
            {getStatsValue(
              reward,
              REWARD_TYPES[reward.type] === REWARD_TYPES.VOUCHER
            )}
            <StatsTabsLabel>
              {reward.label || REWARD_TYPES[reward.type]}
            </StatsTabsLabel>
          </StatsTabsInfo>
        </StatsTabs>
      ))}
    </StatsWrapper>
  );
};

export default ReferralStatsInfo;

ReferralStatsInfo.propTypes = {
  rewards: PropTypes.objectOf(PropTypes.any).isRequired
};
